import { useEffect } from 'react';

import { PortalLoginCustomization } from '@/models/customizationModels';
import { selectPortalLoginCustomizations } from '@/redux/customizations/selectors';
import { useAppSelector } from '@/redux/hooks';

const DEFAULT_COLORS: PortalLoginCustomization = {
  backgroundColor: '#ffffff',
  fieldsBackgroundColor: '#f5f7fc',
  fieldsTextColor: '#424d67',
  forgotPasswordTextColor: '#428bca',
  iconsColor: '#8994aa',
  loginButtonColor: '#3579a6',
  loginButtonTextColor: '#e49d9d',
};

export default function useLoginColors() {
  const customizations = useAppSelector(selectPortalLoginCustomizations);
  const colors = customizations || DEFAULT_COLORS;

  useEffect(() => {
    document.body.style?.setProperty('--amba-login-background-color', colors.backgroundColor);
    document.body.style?.setProperty('--amba-login-fields-background-color', colors.fieldsBackgroundColor);
    document.body.style?.setProperty('--amba-login-fields-text-color', colors.fieldsTextColor);
    document.body.style?.setProperty('--amba-login-forgot-password-text-color', colors.forgotPasswordTextColor);
    document.body.style?.setProperty('--amba-login-icons-color', colors.iconsColor);
    document.body.style?.setProperty('--amba-login-login-button-color', colors.loginButtonColor);
    document.body.style?.setProperty('--amba-login-login-button-text-color', colors.loginButtonTextColor);

    return () => {
      document.body.style?.removeProperty('--amba-login-background-color');
      document.body.style?.removeProperty('--amba-login-fields-background-color');
      document.body.style?.removeProperty('--amba-login-fields-text-color');
      document.body.style?.removeProperty('--amba-login-forgot-password-text-color');
      document.body.style?.removeProperty('--amba-login-icons-color');
      document.body.style?.removeProperty('--amba-login-login-button-color');
      document.body.style?.removeProperty('--amba-login-login-button-text-color');
    };
  }, [colors]);

  return null;
}
